export function formatNumber(value) {
  return new Intl.NumberFormat().format(value ?? 0);
}

export function formatDate(value) {
  if (!value) return '—';
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatDeviceType(type) {
  return type
    ?.split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ') ?? type;
}

export function formatMs(ms) {
  if (ms == null) return '—';
  return `${Math.round(ms)} ms`;
}

export function getErrorMessage(error) {
  return error?.response?.data?.message || error?.message || 'Something went wrong';
}
